export {LayoutSwitcherComponent} from './layout-switcher.component';
export {LayoutService} from './layout.service';
export {SmartadminLayoutModule} from './layout.module';

export * from './footer'
export * from './header'
export * from './navigation'
export * from './ribbon'
export * from './shortcut'





// WEBPACK FOOTER //
// ./src/app/shared/layout/index.ts